import { PropsWithChildren } from 'react'
import Styles from './Section.module.scss'
import { Heading, HeadingLevel } from 'blaze-ui/Heading/Heading'

interface SectionProps
  extends PropsWithChildren<{
    title: string
    level?: HeadingLevel
  }> {}

export const Section = ({ children, title, level = 2 }: PropsWithChildren<SectionProps>) => {
  return (
    <div className={Styles.section}>
      <Heading level={level}>{title}</Heading>
      {children}
    </div>
  )
}
